import { InputBase, IconButton, Paper } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SearchBar = ({ searchTerm, setSearchTerm, onSearch }) => (
  <Paper
    component="form"
    onSubmit={(e) => {
      e.preventDefault();
      onSearch && onSearch(searchTerm);
    }}
    sx={{
      p: "2px 4px",
      display: "flex",
      alignItems: "center",
      width: { xs: 180, sm: 250 },
      border: "1.5px solid #b0b6c3",
      boxShadow: 0,
      borderRadius: 2,
      background: "#fff",
    }}
  >
    <InputBase
      sx={{ ml: 1, flex: 1, fontSize: 13 }} // smaller font
      placeholder="Search…"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      inputProps={{ "aria-label": "search" }}
    />
    <IconButton
      type="submit"
      sx={{ p: "4px", color: "#6366f1" }} // smaller padding
      aria-label="search"
    >
      <SearchIcon sx={{ fontSize: 18 }} /> {/* smaller icon */}
    </IconButton>
  </Paper>
);

export default SearchBar;
